export default __webpack_public_path__ + "static/media/slider1.7662713a.jpg";